import { render, staticRenderFns } from "./defaultVisualSection.vue?vue&type=template&id=70d55190&scoped=true"
import script from "./defaultVisualSection.vue?vue&type=script&lang=ts"
export * from "./defaultVisualSection.vue?vue&type=script&lang=ts"
import style0 from "./defaultVisualSection.vue?vue&type=style&index=0&id=70d55190&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d55190",
  null
  
)

export default component.exports